import * as React from "react";
import PropTypes from 'prop-types';

const SvgTag = props => {
  if (props.id !== "_svgtag") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 36 36" {...props}><path fill="#FFF" d="M13.143 15.313a1.533 1.533 0 112.168-2.17 1.533 1.533 0 01-2.168 2.17zm-2.736-5.418a.511.511 0 00-.512.512v7.232a.515.515 0 00.15.361l10.341 10.341a.51.51 0 00.724 0l7.231-7.231c.2-.2.2-.523 0-.724L18 10.045a.513.513 0 00-.36-.15h-7.233z" fillRule="evenodd" /></svg>;
};

SvgTag.displayName = "_svgtag";
SvgTag.propTypes = {
  id: PropTypes.string
};
SvgTag.defaultProps = {
  id: ''
};
export default SvgTag;